import { action, computed, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from '../ReactComponent';
import { Cancel } from '@mui/icons-material';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import InformacoesProcesso from '@/components/InformacoesProcesso';
import ProcessoApregoado from './ProcessoApregoado';
import IconeDetalhePregao from '@/components/icones/IconeDetalhePregao';

class DetalhePregao extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            registro: computed,
            processo: computed,
            processoApregoado: computed,
            isProcessoApregoado: computed,
            processoDiferenteDoApregoado: computed,
            handleCloseDialog: action,
            handleOpenAnotacoesInformacoesProcesso: action
        });
    }

    get registro() {
        return this.salaSessaoStore.detalhesProcessoApregoado;
    }

    get processo() {
        return this.registro.processo;
    }

    get processoApregoado() {
        return this.sessaoStore.processoApregoado;
    }

    get isProcessoApregoado() {
        return (
            this.processoApregoado && this.processo?.numeroCompleto === this.processoApregoado.processo.numeroCompleto
        );
    }

    get processoDiferenteDoApregoado() {
        return (
            this.sessaoStore.processoApregoado &&
            this.salaSessaoStore.detalhesProcessoApregoado &&
            this.sessaoStore.processoApregoado.processo.numeroCompleto !==
                this.salaSessaoStore.detalhesProcessoApregoado?.processo?.numeroCompleto
        );
    }

    handleCloseDialog = () => {
        this.salaSessaoStore.dialogDetalhesProcessoApregoadoOpen = false;
        this.salaSessaoStore.dialogComplementoAnotacoesOpen = false;
        this.salaSessaoStore.dialogConteudoComplementoAnotacoes = '';
    };

    handleOpenAnotacoesInformacoesProcesso = () => {
        this.salaSessaoStore.dialogComplementoAnotacoesOpen = true;
        this.salaSessaoStore.dialogConteudoComplementoAnotacoes =
            this.registro?.informacaoProcessoSalaSessao?.complementoAnotacoes ?? '';
    };

    render() {
        return (
            this.salaSessaoStore.detalhesProcessoApregoado && (
                <Dialog
                    onClose={this.handleCloseDialog}
                    open={this.salaSessaoStore.dialogDetalhesProcessoApregoadoOpen}
                    fullScreen
                    maxWidth="xl"
                >
                    <DialogTitle sx={{ display: 'flex', justifyContent: 'center', px: 3 }}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                flex: 1
                            }}
                        >
                            <IconeDetalhePregao apregoado={this.isProcessoApregoado} /> Detalhes do processo{' '}
                            {this.salaSessaoStore.detalhesProcessoApregoado?.processo?.numeroCompleto}
                        </Box>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                flex: 1
                            }}
                        >
                            <Box
                                sx={{
                                    border: '1px solid rgba(0, 0, 0, 0.12)',
                                    p: 0.5,
                                    borderRadius: 1,
                                    pr: 1.5
                                }}
                            >
                                <ProcessoApregoado
                                    corDoTexto="black"
                                    semAcao
                                />
                            </Box>
                            {this.processoDiferenteDoApregoado && (
                                <Typography sx={{ color: 'red' }}>
                                    O processo em análise é diferente do processo apregoado.
                                </Typography>
                            )}
                        </Box>
                        <Box sx={{ flex: 1 }} />
                    </DialogTitle>
                    <DialogContent>
                        <InformacoesProcesso
                            visualizacaoPregaoProcesso
                            registro={this.salaSessaoStore.detalhesProcessoApregoado}
                            onOpenAnotacoesInformacoesProcesso={this.handleOpenAnotacoesInformacoesProcesso}
                            ocultarContador
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={this.handleCloseDialog}
                            color="secondary"
                            variant="outlined"
                            endIcon={<Cancel />}
                            sx={{ mr: 2 }}
                        >
                            Fechar
                        </Button>
                    </DialogActions>
                </Dialog>
            )
        );
    }
}

export default inject('stores')(observer(DetalhePregao));
